import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { NotfoundComponent } from './demo/components/notfound/notfound.component';
import { AppLayoutComponent } from "./layout/app.layout.component";
import { AuthGuard } from './core/auth/guards/auth.guard';

@NgModule({
    imports: [
        RouterModule.forRoot([
            {
                path: '', component: AppLayoutComponent,
                children: [
                    { path: 'dashboard', loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule)},
                    { path: 'ums', loadChildren: () => import('./modules/ums/ums.module').then(m => m.UmsModule)},
                    { path: 'courses', loadChildren: () => import('./modules/cources/cources.module').then(m => m.CourcesModule)},
                    // { path: 'auth', loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule),},
                ],
                canActivate:[AuthGuard],
                canActivateChild:[AuthGuard]
                
            },
            { path: 'auth', loadChildren: () => import('./modules/auth/login/login.module').then(m => m.LoginModule) },
            { path: 'landing', loadChildren: () => import('./demo/components/landing/landing.module').then(m => m.LandingModule) },
            { path: 'notfound', component: NotfoundComponent },
            // { path: 'noaccess', component: NoaccessComponent },
            { path: '**', redirectTo: '/notfound' },
        ], { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled', onSameUrlNavigation: 'reload' })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
